import { INVITATION_API } from "../constants/api";
import { InvitationParamModel, InvitationSendParamModel } from "../model/account";
import { getHeaders, getUrl, optionsGet, optionsPost } from "./commonService";
import customAxios from "./customAxios";

export default class InvitationService {

  invitationService(params: InvitationParamModel) {
    let api = INVITATION_API.INVITE;
    api = api.replace("#ID#", params.id.toString());

    const url = getUrl(api);
    const headers = getHeaders(params.tenantName || "");
    const options: any = optionsGet(url, headers)

    return customAxios(options).then((res) => {
      return res.data;
    });
  }



  invitationSendService(params: InvitationSendParamModel) {
    const detail = {
      Model: params.model
    };
    const url = getUrl(INVITATION_API.SEND);
    const headers = getHeaders(params.tenantName || "");
    const options: any = optionsPost(url, headers, detail);

    return customAxios(options).then((res) => {
      return res.data;
    });


  }
}
